import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        // console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        // console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const manualPanCheck = createAccountAsyncThunk(
  "post",
  "manualPanCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/pan_check/"
);

export const manualVoterIdCheck = createAccountAsyncThunk(
  "post",
  "manualVoterIdCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/voterid_check/"
);

export const manualDrugCheck = createAccountAsyncThunk(
  "post",
  "manualDrugCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/candidate_drug_documents/"
);

export const manualReferenceCheck = createAccountAsyncThunk(
  "post",
  "manualReferenceCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/Reference_check/"
);


export const manualAadhaarCheck = createAccountAsyncThunk(
  "post",
  "manualAadhaarCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/aadhar_check/"
);

export const manualBankCheck = createAccountAsyncThunk(
  "post",
  "manualBankCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/bank_verification_check/"
);

export const manualDLCheck = createAccountAsyncThunk(
  "post",
  "manualDLCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/driving_license_check/"
);

export const manualIRRDCheck = createAccountAsyncThunk(
  "post",
  "manualIRRDCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/IRRD_check/"
);

export const manualFACISCheck = createAccountAsyncThunk(
  "post",
  "manualFACISCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/FACIS_check/"
);

export const manualIndianCreditHistoryCheck = createAccountAsyncThunk(
  "post",
  "manualIndianCreditHistoryCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/credit_history_check/"
);

export const manualAddressCheck = createAccountAsyncThunk(
  "post",
  "manualAddressCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/Address_check/"
);

export const manualUANCheck = createAccountAsyncThunk(
  "post",
  "manualUANCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/uan_check/"
);

export const uanInformationVerification = createAccountAsyncThunk(
  "post",
  "uanInformationVerification",
  "application/json",
  "valiantinfo_admin/manual_documents/uan-information-verification/"
);

export const UANCheck = createAccountAsyncThunk(
  "post",
  "UANCheck",
  "application/json",
  "valiantinfo_admin/identity_check_service/uan_check/"
);

export const manualGlobalCheck = createAccountAsyncThunk(
  "post",
  "manualGlobalCheck",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/manual_global_check/"
);

export const manualEducationUpload = createAccountAsyncThunk(
  "post",
  "manualEducationUpload",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/manual_educational_check_new/"
);

export const manualEmploymentUpload = createAccountAsyncThunk(
  "post",
  "manualEmployementUpload",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/manual_employment_check_new/"
);

export const manualCheckSaveEduEmp = createAccountAsyncThunk(
  "post",
  "manualCheckSaveEduEmp",
  "application/json",
  "valiantinfo_admin/manual_documents/manual_check_save_new/"
);

export const educationInsufficient = createAccountAsyncThunk(
  "post",
  "educationInsufficient",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_edu_emp_insufficient/"
);

export const getInsufficientDetails = createAccountAsyncThunk(
  "post",
  "getInsufficientDetails",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_insufficient_candidate_list/"
);

export const fetchInsufficientApprove = createAccountAsyncThunk(
  "post",
  "fetchInsufficientApprove",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_fetch_insufficient_check_wise/"
);

export const approveEducationInsufficient = createAccountAsyncThunk(
  "post",
  "approveEducationInsufficient",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_insufficient_edu_info/"
);

export const approveEmploymentInsufficient = createAccountAsyncThunk(
  "post",
  "approveEmploymentInsufficient",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_insufficient_emp_info/"
);

export const rejectInsufficient = createAccountAsyncThunk(
  "post",
  "rejectInsufficient",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_insufficient_reject/"
);

export const SubmitEmploymentGap = createAccountAsyncThunk(
  "post",
  "SubmitEmploymentGap",
  "multipart/form-data",
  "valiantinfo_admin/manual_documents/employment_gap_verification/"
);

export const ConcludeEmploymentGap = createAccountAsyncThunk(
  "post",
  "ConcludeEmploymentGap",
  "application/json",
  "valiantinfo_admin/manual_documents/employment_gap_save/"
);



